export const firebaseConfig = {
    apiKey: "AIzaSyBJ1DAtAEt4v_lFSf06IUNwCG5vtpPj_5g",
    authDomain: "answer-port.firebaseapp.com",
    projectId: "answer-port",
    storageBucket: "answer-port.appspot.com",
    messagingSenderId: "988264103008",
    appId: "1:988264103008:web:42d9e34542c6a050ce1705",
    measurementId: "G-S3LNJTMFXF"
  };